var set = function(name, value, days) {
	var d = new Date();
	var expires;

	d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
	expires = "expires="+ d.toUTCString();
	document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

var get = function(name) {
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	var c;

	for(var i = 0; i <ca.length; i++) {
		c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name + '=') == 0) {
			return c.substring(name.length + 1, c.length);
		}
	}
	return '';
}

var del = function(name) {
	return set(name, '', -1);
};

export {
	set,
	get,
	del
}